import { useRef } from 'react';
import { Id, toast } from 'react-toastify';

const DELAY = 3 * 60 * 1000; // 3 min

export const useTransactionExpired = () => {
  const timerIdRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const toastIdRef = useRef<Id | undefined>(undefined);

  const setExpiredTimer = () => {
    const timerId = setTimeout(() => {
      const toastId = toast.warning(
        "An error may have occurred. Please check your wallet. If you don't see a transaction confirmation message, try to reload the page and reconnect wallet.",
        { autoClose: false }
      );
      toastIdRef.current = toastId;
    }, DELAY);

    timerIdRef.current = timerId;
  };

  const clearExpiredTimer = () => {
    clearTimeout(timerIdRef.current);
    if (toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
    }
  };

  return { setExpiredTimer, clearExpiredTimer };
};
